module.exports = __webpack_public_path__ + "static/focus-hbr-emotional-intelligence-series-3a3928c2f2caf860d78b1326214196c5.jpg";